/**
 * standaloneViewReducer.js
 * Created by benavja on 1/05/2021.
 */

import initialState from './initialstate';
import * as types from '../actions/actiontypes';

export function standaloneViewReducer(state = initialState.isStandaloneView, action) {
	switch (action.type) {
		case types.SET_IS_STANDALONE_VIEW:
			return action.isStandaloneView;
		default:
			return state;
	}
}
